export class GeoLocationObject {
    accuracy: any = 'null';
    altitude: any = 'null';
    heading: any = 'null';
    latitude: any = '38.16635';
    longitude: any = '-85.72932';
    speed: any = 'null';
}

export interface Coordinates {
    latitude: string;
    longitude: string;
  }

  export interface IOScoords {
    lat: string;
    long: string;
  }


